import { render, staticRenderFns } from "./sk-input-wap.vue?vue&type=template&id=5b9a05c7&"
import script from "./sk-input-wap.vue?vue&type=script&lang=js&"
export * from "./sk-input-wap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports